import {
  browserTracingIntegration,
  graphqlClientIntegration,
  httpClientIntegration,
  httpContextIntegration,
  init
} from '@sentry/react';
import { denyUrls, beforeSend } from '../../../modules/sentry-config.js';

init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    browserTracingIntegration(),
    httpClientIntegration(),
    httpContextIntegration(),
    graphqlClientIntegration({
      endpoints: ['/\/graphql\.json$/']
    })
  ],
  sendDefaultPii: false,
  tracesSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.BUILD_ENVIRONMENT,
  release: import.meta.env.SENTRY_RELEASE,
  denyUrls,
  beforeSend
});
